import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../plugins/i18n";
import ProductMap from "../views/ProductMap";

// lazy loading
const LandingPage = () => import("../views/LandingPage");
const LoginPage = () => import("../views/LoginRegister");
const RegisterPage = () => import("../views/RegisterPage");
const ForgotPasswordPage = () => import("../views/ForgotPasswordPage");
const ProfilePage = () => import("../views/ProfilePage");
const ProductPage = () => import("../views/ProductPage");
const Overview = () =>
  import(/* webpackChunkName: "overview" */ "../views/Overview");
const CategoryOverview = () =>
  import(/* webpackChunkName: "overview" */ "../views/CategoryOverview");
const RecommendationsPage = () =>
  import(/* webpackChunkName: "overview" */ "../views/RecommendationsPage");
const StoreMap = () => import("../views/StoreMap");
const StorePage = () => import("../views/StorePage");
const StoreList = () => import("../views/StoreList");
const BrandPage = () => import("../views/BrandPage");
const AboutUsPage = () => import("../views/AboutUsPage");
const ForBusinessPage = () => import("../views/ForBusinessPage");
// const JobPage = () => import("../views/JobPage");
const CartPage = () => import("../views/CartPage");
const CheckoutPage = () => import("../views/CheckoutPage");
const NotFoundPage = () => import("../views/NotFoundPage");
const VerifyEmailPage = () => import("../views/VerifyEmailPage");
const ResetPasswordPage = () => import("../views/ResetPasswordPage");
const WishlistPage = () => import("../views/WishlistPage");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: LandingPage,
    // redirect: `/${i18n.t("general.women")}/recommendations`,
    meta: { title: "browser.title.home" }
  },
  {
    //temp
    // add lazy loading
    // add browser title and other conf
    path: "/stores",
    name: "stores",
    component: StoreList,
    meta: { title: "browser.title.store_map" }
  },
  {
    //temp
    // add lazy loading
    // add browser title and other conf
    path: "/stores/map",
    name: "StoresMap",
    component: StoreMap,
    meta: { title: "browser.title.store_map", footer: { hidden: true } }
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { title: "browser.title.login_page" }
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
    meta: { title: "browser.title.register_page" }
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: ForgotPasswordPage,
    meta: {
      title: "browser.title.forgot_password_page",
      footer: { hidden: true }
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
    meta: { title: "browser.title.profile_page" }
  },
  {
    path: "/stores/:store",
    name: "StorePage",
    component: StorePage,
    beforeEnter: (to, from, next) => {
      document.title = i18n.t(`store.${to.params.store}`) + " | Gyra";
      next();
    }
  },
  {
    path: "/brands",
    name: "brands",
    component: BrandPage,
    meta: { title: "browser.title.brand_page" }
  },
  {
    path: "/map",
    name: "ProductMap",
    component: ProductMap,
    meta: {
      title: "browser.title.product_map",
      footer: { hidden: true },
      header: { hidden: true }
    }
  },
  {
    path: "/about",
    name: "AboutPage",
    component: AboutUsPage,
    meta: {
      title: "browser.title.about_us",
      header: { hidden: false, noBottom: true }
    }
  },
  {
    path: "/business",
    name: "ForBusinessPage",
    component: ForBusinessPage,
    meta: {
      title: "browser.title.for_business",
      header: { hidden: false, noBottom: true }
    }
  },
  // {
  //   path: "/jobs",
  //   name: "JobPage",
  //   component: JobPage,
  //   meta: {
  //     title: "browser.title.jobs",
  //     header: { hidden: false, noBottom: true }
  //   }
  // },
  {
    path: "/:sex/products",
    name: "Overview",
    component: Overview,
    beforeEnter: (to, from, next) => {
      if (!to.params.sex) {
        to.params.sex = "women";
      }
      next();
    },
    children: [
      {
        path: "recommendations",
        name: "Recommendations",
        component: RecommendationsPage,
        meta: { title: "browser.title.recommendations" }
      },
      {
        path: `${i18n.t("header.clothing")}`,
        name: "clothing",
        component: CategoryOverview,
        props: { category: "clothing" },
        meta: { title: "browser.title.overview_clothes" }
      },
      {
        path: `${i18n.t("header.shoes")}`,
        name: "shoes",
        component: CategoryOverview,
        props: { category: "shoes" },
        meta: { title: "browser.title.overview_shoes" }
      },
      {
        path: `${i18n.t("header.accessories")}`,
        name: "accessories",
        component: CategoryOverview,
        props: { categoryProp: "accessories" },
        meta: { title: "browser.title.overview_accessories" }
      },
      // {
      //   path: `${i18n.t("header.sustainable")}`,
      //   name: "sustainable",
      //   component: CategoryOverview,
      //   props: { sustainableProp: true },
      //   meta: { title: "browser.title.sustainable" }
      // },
      // {
      //   path: `${i18n.t("header.stores")}`,
      //   name: "stores",
      //   component: CategoryOverview,
      //   meta: { title: "browser.title.overview_stores" }
      // },
      // {
      //   path: `${i18n.t("header.stores")}`,
      //   name: "brands",
      //   component: CategoryOverview,
      //   meta: { title: "browser.title.brands" }
      // },
      {
        path: `${i18n.t("header.sale")}`,
        name: "sale",
        component: CategoryOverview,
        props: { onSaleProp: true },
        meta: { title: "browser.title.overview_sale" }
      },
      {
        path: "all",
        name: "ladies",
        component: CategoryOverview,
        meta: { title: "browser.title.all" }
      },
      {
        path: "all",
        name: "gents",
        component: CategoryOverview,
        meta: { title: "browser.title.all" }
      }
    ]
  },
  {
    path: "/product/:id",
    name: "ProductPage",
    component: ProductPage,
    meta: { title: "browser.title.product_page" }
  },
  {
    path: "/cart/:id?",
    name: "CartPage",
    component: CartPage,
    meta: { title: "browser.title.cart_page" }
  },
  {
    path: "/wishlist",
    name: "WishlistPage",
    component: WishlistPage,
    meta: { title: "browser.title.wishlist_page" }
  },
  {
    path: "//checkout/:cartId?",
    name: "CheckoutPage",
    component: CheckoutPage,
    meta: { title: "browser.title.cart_page" }
  },
  {
    path: "/verify_email",
    name: "VerifyEmailPage",
    component: VerifyEmailPage,
    meta: { title: "browser.title.verify_email" }
  },
  {
    path: "/reset_password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
    meta: { title: "browser.title.reset_password" }
  },
  {
    path: "*",
    name: "NotFoundPage",
    component: NotFoundPage,
    meta: {
      title: "browser.title.not_found",
      header: { hidden: false, noBottom: true }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    const savePositionNames = /sale|stores|brands|accessories|sustainable|shoes|clothing/;
    if (from.name === "ProductPage" && savePositionNames.test(to.name)) {
      if (savedPosition) {
        return savedPosition;
      }
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (!to.params.sex) {
    to.params.sex = "women";
  }
  if (to.name === "ProductPage")
    document.title =
      to.params.name || i18n.t("browser.title.product_page") + " | Gyra";
  else document.title = i18n.t(to.meta.title) + " | Gyra";
  next();
});

export default router;
